<script>
    import request from './request.vue';
	import Article from './article.model.vue';    
    import { format } from "date-fns";
    
    const companyArticleSchema = [
        {
			name: "id",
			displayName: "Código",
			kind: "text",
			validation: "",
			placeholder: "",
			defaultSort: true,
			readOnly: true,
			search: {
				show: false,
				endWildcard: true,
				startWildcard: true,
			},
		},
        {
			name: "companyId",
			displayName: "Empresa",
			kind: "text",
			validation: "",
			defaultSort: true,
			readOnly: true,
			formatter: value => parseInt(value, 10),
			search: {
				show: false,
				endWildcard: true,
				startWildcard: true,
			},
		},
        {
			name: "articleId",
			displayName: "Teste",
			kind: "select",
			validation: "required",
			placeholder: "",
			options: [],
			search: {
				show: true,
				endWildcard: false,
				startWildcard: false,
			},
		},
		{
			name: "articleName",
			displayName: "Teste",
			kind: "text",			
			placeholder: "",
			hidden: true,
			options: [],
			search: {
				show: true,
				endWildcard: false,
				startWildcard: false,
			},
		},
        {
			name: "creationDate",
			displayName: "Data do cadastro",
			kind: "text",
			validation: "",
			placeholder: "",
			readOnly: true,
			notInFilters: true,
			formatter: value => format(value, "DD/MM/YYYY HH:mm"),
			creationHidden: true,
			search: {
				show: true,
				endWildcard: true,
				startWildcard: true,
			},
		},
    ];

    Article.findTestsByCategory(700)
		.then((category) => {
			companyArticleSchema.find(field => field.name === "articleId").options = category.tests.map(article => ({
				name: article.name,
				value: article.id,
			}));
		})
		.catch((err) => console.log(err));

    export default {
        create: async function(entity) {
            const response = await request.send("companyArticle", "create", entity, true);
            return response.data;
        },
        getInfo: async function(id) {
            const response = await request.send("companyArticle", "read", { id }, true);
            return response.data;
        },
        updateInfo: async function(entity) {
            const response = await request.send("companyArticle", "update", entity, true);
            return response.data;
        },
        remove: async function(id) {
            return request.send("companyArticle", "delete", { id }, true);
        },
        search: async function(parameters) {
			return request.send("companyArticle", "search", parameters, true);
		},
		getAll: async function() {
			const response = await request.send("companyArticle", "getAll", {}, true);
			return response.data;
		},
		getSchema: function() {
			return companyArticleSchema;
		},
    }

</script>